import { render, staticRenderFns } from "./side-item.vue?vue&type=template&id=b773fc7a&scoped=true&"
import script from "./side-item.vue?vue&type=script&lang=js&"
export * from "./side-item.vue?vue&type=script&lang=js&"
import style0 from "./side-item.vue?vue&type=style&index=0&id=b773fc7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b773fc7a",
  null
  
)

export default component.exports